import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-cancel-dialog',
  standalone: true,
  imports: [MatDialogModule,MatButtonModule,MatIconModule,MatDialogClose],
    template: `<div class="button-container"><button mat-stroked-button
    style="margin-right: 5px; margin-left: 5px"
    color="primary"
    [mat-dialog-close]="true"
    name="Cancelar">
  Cancelar
  </button></div>`,
  styleUrls: ['./button-cancel-dialog.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCancelDialogComponent { }
